import React from 'react'
// import Sidebar from '../../components/sidebar'
import Hero from '../../components/hero'
import HowWeHelp from '../../components/how-we-help'
// import ValueProps from '../../components/value-props'
import FeaturedProjects from '../../components/featured-projects'
import FeedbackClients from '../../components/feedback-clients'
import ContactUs from '../../components/contact-us'
import Footer from '../../components/footer'
import "./Homepage.css"








export default function Homepage() {

  return (
    <div
      className="homepage-wrapper"
    >
      <Hero />
      {/* <Sidebar /> */}
      <HowWeHelp />
      {/* <ValueProps /> */}
      <FeaturedProjects />
      <FeedbackClients />
      <ContactUs />
      <Footer />
    </div>
  )
}
